<template>
  <div class="grid grid-cols-1 gap-4">
    <div
      class="pb-4 border-b border-gray-200 space-y-3 sm:flex sm:items-center sm:justify-between sm:space-x-4 sm:space-y-0"
    >
      <div class="inline-flex ">
        <div class="relative rounded-md shadow-sm">
          <input
            id="search"
            v-model="searchinputbuffer"
            class="focus:ring-indigo-500 focus:border-indigo-500 block w-full h-full pb-1 pl-3 pr-12 sm:text-sm border-gray-300 rounded-md"
            placeholder="Buscar"
          />
          <div class="absolute inset-y-0 right-0 flex items-center">
            <select
              @change="onFilterChange($event)"
              class="focus:ring-indigo-500 focus:border-indigo-500 h-full py-0 pl-2 pr-7 border-transparent bg-transparent text-gray-500 sm:text-sm rounded-md"
            >
              <option value="code">Código</option>
              <option value="product">Producto</option>
              <option value="location">Ubicación</option>
            </select>
          </div>
        </div>
        <span class="inline-flex rounded-md shadow-sm pl-4">
          <button
            v-on:click="onSearch"
            type="button"
            class="inline-flex items-center px-2.5 py-1.5 border border-gray-300 text-xs leading-4 font-medium rounded text-gray-700 bg-white hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:ring-blue active:text-gray-800 active:bg-gray-50 transition ease-in-out duration-150"
          >
            <!-- Heroicon name: mail -->
            <svg
              class="-ml-0.5 mr-2 h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
            {{ $t('message.wms.stock.buscar') }}
          </button>
        </span>
      </div>
      <div class="flex justify-end">
        <span class="inline-flex shadow-sm rounded-md ml-3">
          <button
            v-on:click="toggleAddItem"
            type="button"
            class="inline-flex items-center px-4 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:ring-indigo focus:border-indigo-700 active:bg-indigo-700 transition duration-150 ease-in-out h-10"
          >
            {{ $t('message.wms.stock.nuevoitem') }}
          </button>
        </span>
      </div>
    </div>
    <items-table :searchinput="searchinput" :filtertype="filtertype" />
    <dynamic-form
      v-on:toggle-form="toggleAddItem"
      v-if="additemmodal"
      formtype="wmsadditem"
    />
  </div>
</template>

<script>
import ItemsTable from '@/components/wms/ItemsTable';
import DynamicForm from '@/components/DynamicForm/DynamicForm';
export default {
  name: 'stock',
  components: { ItemsTable, DynamicForm },
  data() {
    return {
      searchinput: '',
      searchinputbuffer: '',
      filtertype: 'code',
      additemmodal: false
    };
  },
  methods: {
    onFilterChange(event) {
      this.filtertype = event.target.value;
    },
    toggleAddItem() {
      this.additemmodal = !this.additemmodal;
    },
    onSearch() {
      this.searchinput = this.searchinputbuffer;
    }
  }
};
</script>
